
const FutureChurch = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <div
        className="relative w-full bg-cover bg-center h-[550px] flex items-center justify-center"
        style={{
          backgroundImage: "url('./images/future-church.png')",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative text-center px-6 md:px-12 lg:px-20 max-w-4xl">
          <h1 className="text-white text-3xl md:text-5xl font-bold leading-tight mb-4">
            Building the Future Church — One Sunday School Class at a Time
          </h1>
          <p className="text-gray-200 text-lg md:text-xl">
            How Sunday School nurtures the next generation of faithful, committed, and active church members.
          </p>
        </div>
      </div>

      <section className="body--container w-full px-4 py-10 md:px-12 lg:px-24 xl:px-32">
        <div className="mx-auto max-w-4xl text-gray-800 leading-relaxed">
          <p className="mb-6">
            The Church is a living, growing community of faith. Its strength, vibrancy, and longevity depend on the next generation of believers. 
            One of the most powerful tools for shaping the future Church is Sunday School, where intentional teaching, mentorship, and community lay the foundation for lifelong faith.
          </p>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              1. Planting Seeds of Faith Early
            </h2>
            <p>
              Children are like fertile soil, ready to receive seeds that will grow into lasting beliefs. Sunday School introduces Scripture, prayer, 
              and Christian values in engaging ways, helping children understand God’s love, core moral values, and the importance of worship and service.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              2. Developing Spiritual Leaders
            </h2>
            <p>
              Sunday School trains future leaders by encouraging participation in Bible readings, leading prayers or small activities, and serving in ministries. 
              These experiences build confidence, responsibility, and leadership skills for active church involvement.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              3. Creating a Sense of Belonging
            </h2>
            <p>
              Peer friendships, mentorship from teachers, and group activities foster teamwork, empathy, and shared purpose. 
              Children who feel part of the community develop a lifelong connection to the Church.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              4. Reinforcing Biblical Knowledge and Life Skills
            </h2>
            <p>
              Sunday School combines spiritual lessons with practical life skills. Stories from the Bible teach moral decision-making, 
              while lessons on forgiveness, generosity, and humility guide children in applying faith to everyday life.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              5. Encouraging Family Involvement
            </h2>
            <p>
              Sunday School supports parents by providing resources and opportunities to engage in their children’s spiritual education. 
              Family participation ensures faith is modeled consistently at home and in church.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              6. Cultivating a Lifelong Love for God and the Church
            </h2>
            <p>
              Engaging lessons, caring teachers, and a supportive community inspire children to develop a personal relationship with God, 
              participate in worship and service, and continue learning throughout their lives.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              Conclusion: One Class, One Generation, One Church
            </h2>
            <p>
              Building the future Church happens one Sunday School class at a time. Each lesson, story, prayer, and interaction nurtures the next generation of believers. 
              By investing in Sunday School, churches invest in children whose faith, values, and leadership will shape the Church for years to come.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-12">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-6">
          <div className="flex flex-wrap gap-2">
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Sunday School</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Faith Education</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Church Growth</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Leadership</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FutureChurch;